import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Button, Select, MenuItem, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, InputAdornment, Autocomplete, ButtonGroup, Tooltip, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { CustomFormBody } from "../../components/common/CustomForm/CustomFormBody";
import { CustomFormHeader } from "../../components/common/CustomForm/CustomFormHeader";
import { CustomForm } from "../../components/common/CustomForm/CustomForm";
import { CustomFormFooter } from "../../components/common/CustomForm/CustomFormFooter";
import { SelectProductsModal } from "./components/SelectProductsModal";
import { withStyles } from '@mui/styles';
import { usePriceListStore } from "../../hooks/usePriceListStore";
import { readLocalStorage } from "../../toolbox/helpers/local-storage-helpers";
import { LocalStorageKey } from "../../types";
import { useBranchOfficeStore } from "../../hooks/useBranchOfficeStore";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SearchIcon from '@mui/icons-material/Search';
import { useSellerStore } from "../../hooks/useSellerStore";
import { useSegmentStore } from "../../hooks/useSegmentStore";
import { useSupplierStore } from "../../hooks/useSupplierStore";
import { CustomSnackbar } from "../../components/common/CustomSnackbar/CustomSnackbar";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import '../../assets/styles/facturacionv3-app.css'

const StyledTableCell = withStyles((theme) => ({
    head: {
        color: theme.palette.common.black,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'code', label: 'Código', align: 'center' },
    { type: 'text', field: 'name', label: 'Nombre', align: 'center' },
    // { type: 'text', field: 'cost', label: 'Costo', align:'center' },
    { type: 'text', field: 'price', label: 'Precio', align: 'center' },
    { type: 'text', field: 'discount', label: 'Descuento', align: 'center' },
    // { type: 'text', field: 'stock', label: 'Cantidad', align:'center' },
    // { type: 'text', field: 'subtotal', label: 'Subtotal', align:'center' },
    { type: 'text', field: 'new_price', label: 'Precio Final', align: 'center' },
];

type Values = {
    id: number,
    code: string,
    name: string,
    description: string,
    validity_date: string,
    document_state: string,
    quantity_products: number,
    type: string,
    discounttype: string,
    max_desc_item: number,
    max_desc_global: number,
    products: any,
    idbranchoffices: any,
    idsalesman: any,
    idsegments: any,
    idcustomers: any,
    assignedvalue: number,
    total: number,
    status: string,
}

const states = [
    { name: 'Activo', value: '1' },
    { name: 'Desactivo', value: '0' },
]

const types = [
    { name: 'General', value: '1' },
    { name: 'Por sucursal', value: '2' },
    { name: 'Por vendedor', value: '3' },
    { name: 'Por segmento', value: '4' },
    { name: 'Por cliente', value: '5' },
]

const discounttype = [
    { name: '$', value: '1' },
    { name: '%', value: '2' },
    { name: 'Libre', value: '3' },
]

export const PriceListForm: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, storeSelected, homelist, clearState } = props;

    const { action, createPriceList, editPriceList } = usePriceListStore();

    const { getBranchOfficeByCompany } = useBranchOfficeStore();
    const { getSellers } = useSellerStore();
    const { getSegments } = useSegmentStore();
    const { getSuppliers } = useSupplierStore();

    const userData = readLocalStorage(LocalStorageKey.USER_DATA);
    const idcompany = userData?.idcompany;
    const today = new Date().toISOString().split('T')[0];

    const [loading, setLoading] = useState<boolean>(false);
    const [loadingdata, setLoadingdata] = useState<boolean>(false);
    const [showListProducts, setShowListProducts] = useState<boolean>(false);

    const [branchOffices, setBranchOffices] = useState<any>([]);
    const [sellers, setSellers] = useState<any>([]);
    const [segments, setSegments] = useState<any>([]);
    const [customers, setCustomers] = useState<any>([]);

    const [productsSelected, setProductsSelected] = useState<any>([]);
    const [filter, setFilter] = useState<any>([]);
    const [total, setTotal] = useState(0);

    const [state, setState] = useState<any>({
        discount: false,
        stock: false,
    });

    const [data, setData] = useState<Values>({
        id: storeSelected ? storeSelected.id : '',
        code: storeSelected ? storeSelected.code : '',
        name: storeSelected ? storeSelected.name : '',
        description: storeSelected ? storeSelected.description : '',
        validity_date: storeSelected ? storeSelected.validity_date : '',
        document_state: storeSelected ? storeSelected.document_state : '1',
        quantity_products: storeSelected ? storeSelected.quantity_products : 0,
        type: storeSelected ? storeSelected.type : '5',
        discounttype: storeSelected ? storeSelected.discounttype : '3',
        max_desc_item: storeSelected ? storeSelected.max_desc_item : '',
        max_desc_global: storeSelected ? storeSelected.max_desc_global : '',
        products: storeSelected ? storeSelected.products : '',
        idbranchoffices: storeSelected ? storeSelected.idbranchoffices : '',
        idsalesman: storeSelected ? storeSelected.idsalesman : '',
        idsegments: storeSelected ? storeSelected.idsegments : '',
        idcustomers: storeSelected ? storeSelected.idcustomers : '',
        assignedvalue: storeSelected ? storeSelected.assignedvalue : '',
        total: storeSelected ? storeSelected.total : 0,
        status: storeSelected ? storeSelected.status : '1',
    });

    useEffect(() => {
        if (data.discounttype === '3') {
            setState({ discount: false, stock: false });
        }
    }, [data.discounttype]);

    useEffect(() => {
        getSupplierApi();
    }, [])

    const getBranchOfficeApi = async (search = '') => {
        try {
            setLoadingdata(true);
            const response = await getBranchOfficeByCompany(search);
            if (!response) {
                setBranchOffices([]);
                setLoadingdata(false);
                return false;
            } else {
                setBranchOffices(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getSellersApi = async (search = '') => {
        try {
            setLoadingdata(true);
            const response = await getSellers(search);
            if (!response) {
                setSellers([]);
                setLoadingdata(false);
                return false;
            } else {
                setSellers(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getSegmentsApi = async (search = '') => {
        try {
            setLoadingdata(true);
            const response = await getSegments(search);
            if (!response) {
                setSegments([]);
                setLoadingdata(false);
                return false;
            } else {
                setSegments(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getSupplierApi = async () => {
        try {
            setLoadingdata(true);
            const response = await getSuppliers({ type: 1 });
            console.log(response)
            if (!response) {
                setCustomers([]);
                setLoadingdata(false);
                return false;
            } else {
                setCustomers(response?.detail || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const validateForm = (values) => {
        let errors: any = {};
        if (!values.code) errors.code = "el campo es requerido";
        if (!values.name) errors.name = "el campo es requerido";
        // if(!values.validity_date) errors.validity_date = "el campo es requerido";
        // if(!values.quantity_products) errors.quantity_products = "el campo es requerido";
        if (!values.type) errors.type = "el campo es requerido";
        if (values.type == '2' && !values.idbranchoffices) errors.idbranchoffices = "el campo es requerido";
        if (values.type == '3' && !values.idsalesman) errors.idsalesman = "el campo es requerido";
        if (values.type == '4' && !values.idsegments) errors.idsegments = "el campo es requerido";
        if (values.type == '5' && !values.idcustomers) errors.idcustomers = "el campo es requerido";
        if (values.discounttype !== '3' && values.assignedvalue <= 0) {
            errors.assignedvalue = "El descuento debe ser mayor a 0";
        }
        console.log(errors)
        return errors;
    }

    const changeTypeList = (type: string) => {
        switch (type) {
            case '2':
                getBranchOfficeApi();
                break;
            case '3':
                getSellersApi();
                break;
            case '4':
                getSegmentsApi();
                break;
            case '5':
                getSupplierApi();
                break;
        }
    }

    const addProducts = () => {
        setShowListProducts(true);
    }

    const handleKeyDown = (event) => {
        const keyCode = event.keyCode || event.which;
        if (keyCode === 189 || keyCode === 109) {
            event.preventDefault();
        }
    };

    const onDeleteProduct = (row) => {
        const products = filter.filter(product => product.id !== row.id)
        setFilter([...products]);

        const newTotal = products.reduce((acc, product) => {
            return acc + (product.price * product.stock);
        }, 0);
        setTotal(newTotal);
    }

    const handleSearch = (searchTerm) => {
        const filtered = productsSelected.filter((product) =>
            product.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilter(filtered);
        if (!searchTerm) {
            setFilter([...productsSelected])
        }
    };

    const onSubmit = async (values) => {
        setLoading(true);

        if (filter && filter.length > 0 && total < 0) {
            setLoading(false)
            return CustomSnackbar('error', "Asegurese de completar correctamente todos los inputs de la tabla")
        };

        const formattedFilter = filter.map((product) => ({
            ...product,
            price: product.new_price || product.price, // Usar `new_price` si existe, de lo contrario usar `price`
        }));

        const quantityproducts = (formattedFilter || []).length;

        let formdata = {
            ...values,
            total: total,
            products: formattedFilter || [],
            quantity_products: quantityproducts,
            idcompany: idcompany
        }

        switch (values.type) {
            case '2':
                const idbranchoffices = (values.idbranchoffices).map(branch => branch.id) || [];
                formdata = { ...formdata, idbranchoffices: idbranchoffices }
                break;
            case '3':
                const idsalesman = (values.idsalesman).map(seller => seller.id) || [];
                formdata = { ...formdata, idsalesman: idsalesman }
                break;
            case '4':
                const idsegments = (values.idsegments).map(segment => segment.id) || [];
                formdata = { ...formdata, idsegments: idsegments }
                break;
            case '5':
                const idcustomers = (values.idcustomers).map(customer => customer.id) || [];
                formdata = { ...formdata, idcustomers: idcustomers }
                break;
        }

        if (storeSelected) {
            const response: any = await editPriceList(storeSelected.id, formdata);
            if (response) {
                homelist && homelist();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            } else {
                setLoading(false);
                return false;
            }
        } else {
            const response: any = await createPriceList(formdata);
            if (response) {
                homelist && homelist();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            } else {
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <>
            <CustomForm >
                <CustomFormHeader
                    title={'Agregar lista de precio'}
                    onCancel={closeModal}
                    clearState={clearState}
                >
                </CustomFormHeader>
                <CustomFormBody>

                    <Formik initialValues={data} enableReinitialize validate={(values) => validateForm(values)} onSubmit={onSubmit}>
                        {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                            return (
                                <form onSubmit={handleSubmit}>
                                    <Grid container sx={{ padding: '3px 20px 20px 20px' }}>
                                        <Grid item container xs={12} spacing={2}>
                                            <Grid item xs={12} md={4}>
                                                <FormLabel>Código:</FormLabel>
                                                <TextField
                                                    id="code"
                                                    type="text"
                                                    name="code"
                                                    fullWidth
                                                    size="small"
                                                    value={values.code}
                                                    onChange={handleChange}
                                                    error={errors.code && touched.code ? true : false}
                                                    helperText={errors.code && touched.code ? errors.code : ''}
                                                    inputProps={{ readOnly: action == 'detail' }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <FormLabel>Nombre:</FormLabel>
                                                <TextField
                                                    id="name"
                                                    type="text"
                                                    name="name"
                                                    fullWidth
                                                    size="small"
                                                    value={values.name}
                                                    onChange={handleChange}
                                                    error={errors.name && touched.name ? true : false}
                                                    helperText={errors.name && touched.name ? errors.name : ''}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <FormLabel>Vigencia:</FormLabel>
                                                <TextField
                                                    id="validity_date"
                                                    type="date"
                                                    name="validity_date"
                                                    fullWidth
                                                    size="small"
                                                    value={values.validity_date}
                                                    onChange={handleChange}
                                                    error={errors.validity_date && touched.validity_date ? true : false}
                                                    helperText={errors.validity_date && touched.validity_date ? errors.validity_date : ''}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    inputProps={{
                                                        min: today,
                                                    }}
                                                />
                                            </Grid>
                                            {/* <Grid item xs={12} md={4}>
                                            <FormLabel>Cantidad de productos:</FormLabel>
                                            <TextField
                                                id="quantity_products"
                                                type="number" 
                                                name="quantity_products"
                                                fullWidth
                                                size="small"
                                                value={(filter || []).length}
                                                inputProps={{ readOnly: true }}
                                            />
                                        </Grid> */}
                                            <Grid item xs={12} md={4}>
                                                <FormLabel>Tipo:</FormLabel>
                                                <Select
                                                    id="type"
                                                    value={values.type}
                                                    size="small"
                                                    onChange={(event) => {
                                                        setFieldValue("type", event.target.value);
                                                        setFieldValue("idbranchoffices", "");
                                                        setFieldValue("idsalesman", "");
                                                        setFieldValue("idsegments", "");
                                                        setFieldValue("idcustomers", "");
                                                        changeTypeList(event.target.value);
                                                    }}
                                                    error={errors.type && touched.type ? true : false}
                                                    fullWidth
                                                    inputProps={{ readOnly: action == 'detail' }}
                                                    disabled
                                                >
                                                    {
                                                        types.map((type, i) => {
                                                            return <MenuItem key={i} value={type.value}>{type.name}</MenuItem>;
                                                        })
                                                    }
                                                </Select>
                                            </Grid>
                                            {
                                                values.type == '2' && (
                                                    <Grid item xs={12} md={4}>
                                                        <FormLabel>Sucursales:</FormLabel>
                                                        <Autocomplete
                                                            multiple
                                                            id="combo-box-demo"
                                                            value={values.idbranchoffices || []}
                                                            options={branchOffices || []}
                                                            getOptionLabel={(option) => option.name || ""}
                                                            fullWidth
                                                            renderInput={(params) => <TextField {...params}
                                                                error={errors.idbranchoffices && touched.idbranchoffices ? true : false}
                                                            />}
                                                            onChange={(e, newValue) => {
                                                                setFieldValue("idbranchoffices", newValue);
                                                            }}
                                                            readOnly={action == 'detail'}
                                                            loading={loadingdata}
                                                            size="small"
                                                            limitTags={2}
                                                        />
                                                    </Grid>
                                                )
                                            }
                                            {
                                                values.type == '3' && (
                                                    <Grid item xs={12} md={4}>
                                                        <FormLabel>Vendedores:</FormLabel>
                                                        <Autocomplete
                                                            multiple
                                                            id="combo-box-demo"
                                                            value={values.idsalesman || []}
                                                            options={sellers || []}
                                                            getOptionLabel={(option) => option.name + ' ' + option.surname || ""}
                                                            fullWidth
                                                            renderInput={(params) => <TextField {...params} />}
                                                            onChange={(e, newValue) => {
                                                                setFieldValue("idsalesman", newValue);
                                                            }}
                                                            readOnly={action == 'detail'}
                                                            loading={loadingdata}
                                                            limitTags={2}
                                                            size="small"
                                                        />
                                                    </Grid>
                                                )
                                            }
                                            {
                                                values.type == '4' && (
                                                    <Grid item xs={12} md={4}>
                                                        <FormLabel>Segmentos:</FormLabel>
                                                        <Autocomplete
                                                            multiple
                                                            id="combo-box-demo"
                                                            value={values.idsegments || []}
                                                            options={segments || []}
                                                            getOptionLabel={(option) => option.name || ""}
                                                            fullWidth
                                                            renderInput={(params) => <TextField {...params} />}
                                                            onChange={(e, newValue) => {
                                                                setFieldValue("idsegments", newValue);
                                                            }}
                                                            readOnly={action == 'detail'}
                                                            loading={loadingdata}
                                                            limitTags={2}
                                                            size="small"
                                                        />
                                                    </Grid>
                                                )
                                            }
                                            {
                                                values.type == '5' && (
                                                    <Grid item xs={12} md={4}>
                                                        <FormLabel>Clientes:</FormLabel>
                                                        <Autocomplete
                                                            multiple
                                                            id="combo-box-demo"
                                                            value={values.idcustomers || []}
                                                            options={customers || []}
                                                            getOptionLabel={(option) => option.name_rz + ' - ' + option.rut || ""}
                                                            fullWidth
                                                            renderInput={(params) => <TextField {...params} />}
                                                            onChange={(e, newValue) => {
                                                                setFieldValue("idcustomers", newValue);
                                                            }}
                                                            readOnly={action == 'detail'}
                                                            loading={loadingdata}
                                                            limitTags={2}
                                                            size="small"
                                                        />
                                                    </Grid>
                                                )
                                            }
                                            <Grid item xs={12} md={4}>
                                                <FormLabel>Tipo de descuento:</FormLabel>
                                                <Select
                                                    id="discounttype"
                                                    value={values.discounttype}
                                                    size="small"
                                                    onChange={(event) => {
                                                        setFieldValue("discounttype", event.target.value);

                                                        if (event.target.value === '3') {
                                                            const updatedFilter = filter.map((row) => ({
                                                                ...row,
                                                                discount: 0,
                                                                new_price: row.price,
                                                            }));
                                                            setFilter(updatedFilter);
                                                            setFieldValue("assignedvalue", 0);
                                                        } else {
                                                            const updatedFilter = filter.map((row) => {
                                                                const discount = values.assignedvalue;
                                                                if (event.target.value === '1') {
                                                                    row.new_price = Math.max(row.price - discount, 0);
                                                                } else if (event.target.value === '2') {
                                                                    row.new_price = Math.max(row.price - (row.price * discount / 100), 0);
                                                                }
                                                                return row;
                                                            });
                                                            setFilter(updatedFilter);
                                                        }
                                                    }}
                                                    fullWidth
                                                    inputProps={{ readOnly: action === 'detail' }}
                                                >
                                                    {discounttype.map((discount, i) => (
                                                        <MenuItem key={i} value={discount.value}>
                                                            {discount.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>


                                            </Grid>
                                            {/* <Grid item xs={12} md={4}>
                                            <FormLabel>Máximo descuento por item:</FormLabel>
                                            <TextField
                                                id="max_desc_item"
                                                type="number" 
                                                name="max_desc_item"
                                                fullWidth
                                                size="small"
                                                value={values.max_desc_item}
                                                onChange={handleChange}
                                                onKeyDown={handleKeyDown}
                                                error={errors.max_desc_item && touched.max_desc_item ? true : false}
                                                helperText={errors.max_desc_item && touched.max_desc_item ? errors.max_desc_item : ''}
                                                inputProps={{
                                                    readOnly: values.discounttype == '3',
                                                    max: values.discounttype == '2' ? 100 : undefined
                                                }}
                                            />
                                        </Grid> */}
                                            {/* <Grid item xs={12} md={4}>
                                            <FormLabel>Máximo descuento global:</FormLabel>
                                            <TextField
                                                id="max_desc_global"
                                                type="number" 
                                                name="max_desc_global"
                                                fullWidth
                                                size="small"
                                                value={values.max_desc_global}
                                                onChange={handleChange}
                                                onKeyDown={handleKeyDown}
                                                error={errors.max_desc_global && touched.max_desc_global ? true : false}
                                                helperText={errors.max_desc_global && touched.max_desc_global ? errors.max_desc_global : ''}
                                                inputProps={{
                                                    readOnly: values.discounttype == '3',
                                                    max: values.discounttype == '2' ? 100 : undefined
                                                }}
                                            />
                                        </Grid> */}
                                            {/* <Grid item xs={12} md={4}>
                                            <FormLabel>Estado:</FormLabel>
                                            <Select
                                                id="status"
                                                value={values.status}
                                                size="small"
                                                onChange={(event) => { 
                                                    setFieldValue("status", event.target.value);
                                                }}
                                                error={ errors.status && touched.status ? true : false }
                                                fullWidth
                                                inputProps={{ readOnly: action == 'detail' }}
                                            >
                                                {
                                                    states.map((state, i) => {
                                                        return <MenuItem key={i} value={state.value}>{state.name}</MenuItem>;
                                                    })
                                                }
                                            </Select>
                                        </Grid> */}
                                            <Grid item xs={12} md={12}>
                                                <FormLabel>Descripción:</FormLabel>
                                                <TextField
                                                    id="description"
                                                    type="text"
                                                    name="description"
                                                    fullWidth
                                                    size="small"
                                                    value={values.description}
                                                    onChange={handleChange}
                                                    error={errors.description && touched.description ? true : false}
                                                    helperText={errors.description && touched.description ? errors.description : ''}
                                                />
                                            </Grid>

                                            {
                                                values.discounttype !== '3' &&
                                                <Grid item xs={12} md={4}>
                                                    <FormLabel>Descuento general:</FormLabel>
                                                    <TextField
                                                        id="general-discount"
                                                        type="text" // Cambia a texto para permitir valores como "020"
                                                        fullWidth
                                                        size="small"
                                                        value={values.assignedvalue}
                                                        onChange={(e) => {
                                                            const inputValue = e.target.value;

                                                            // Validar que sea un número válido o vacío
                                                            if (/^\d*$/.test(inputValue)) {
                                                                setFieldValue("assignedvalue", inputValue);

                                                                // Actualizar los productos solo si el valor es válido
                                                                const discount = parseFloat(inputValue) || 0;
                                                                const updatedProducts = filter.map((product) => {
                                                                    const discountType = values.discounttype;

                                                                    product.discount = discount;

                                                                    if (discountType === '1') { // Descuento en pesos
                                                                        product.new_price = Math.max(product.price - discount, 0);
                                                                    } else if (discountType === '2') { // Descuento en porcentaje
                                                                        product.new_price = Math.max(product.price - (product.price * discount / 100), 0);
                                                                    } else {
                                                                        product.new_price = product.price; // Sin descuento
                                                                    }

                                                                    return product;
                                                                });

                                                                setFilter(updatedProducts);
                                                            }
                                                        }}
                                                        error={errors.assignedvalue && touched.assignedvalue ? true : false}
                                                        helperText={errors.assignedvalue && touched.assignedvalue ? errors.assignedvalue : ''}
                                                    />


                                                </Grid>
                                            }



                                            <Grid item xs={12}>
                                                <Grid item xs={12} sx={{ marginBottom: '10px' }}>
                                                    <FormLabel>Lista de productos</FormLabel>
                                                </Grid>
                                                <Grid item xs={12} display='flex' justifyContent='space-between' alignContent='center' alignItems='center' mb={2}>
                                                    <Grid item>
                                                        <TextField
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <SearchIcon fontSize="small" />
                                                                    </InputAdornment>
                                                                )
                                                            }}
                                                            onChange={(e) => { handleSearch(e.target.value) }}
                                                            placeholder="Buscar..."
                                                            size="small"
                                                        />
                                                    </Grid>
                                                    <Button onClick={addProducts} size="small" variant="contained" className='btn-secondary'>
                                                        {'Agregar productos'}
                                                    </Button>
                                                </Grid>

                                                <TableContainer>
                                                    <Table>
                                                        <TableHead className="table-header">
                                                            <TableRow>
                                                                {columns.map((column: any, i: any) => (
                                                                    <StyledTableCell className="table-header-text" key={i} align='center'>
                                                                        {column.label}
                                                                    </StyledTableCell>
                                                                ))}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {
                                                                filter.length > 0 ? (
                                                                    filter.map((row) => (
                                                                        <TableRow key={row.id}>
                                                                            <TableCell className="cellTable" align="center" style={{ fontSize: "13px" }}>
                                                                                <ButtonGroup variant="contained" aria-label="button-group-custom-table" style={{ padding: "0px 5px", color: "#808080" }}>
                                                                                    <Tooltip title={'Eliminar'}>
                                                                                        <IconButton size="small" color="inherit" aria-label="delete" onClick={() => { onDeleteProduct(row) }}>
                                                                                            <DeleteOutlineIcon fontSize='small' />
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                </ButtonGroup>
                                                                            </TableCell>
                                                                            <TableCell align="center">{row.code_system}</TableCell>
                                                                            <TableCell align="center">{row.name}</TableCell>
                                                                            {/* <TableCell align="center">
                                                                            <TextField
                                                                                id={"input-" + row.id}
                                                                                type="number"
                                                                                fullWidth
                                                                                size="small"
                                                                                value={row.cost}
                                                                                InputProps={{
                                                                                    startAdornment: <InputAdornment position="start">{row.cointypesymbol}</InputAdornment>,
                                                                                }}
                                                                                inputProps={{ min: 0 }}
                                                                                onChange={(e) => changeInputs(row.id, parseFloat(e.target.value), 'cost')}
                                                                            />
                                                                        </TableCell> */}

                                                                            <TableCell align="center">
                                                                                {row.price ? row.price.toFixed(0) : 0}
                                                                            </TableCell>
                                                                            <TableCell align="center">
                                                                                {row.discount ? row.discount.toFixed(0) : 0}
                                                                            </TableCell>
                                                                            {/* <TableCell align="center">
                                                                            <TextField
                                                                                id={"input-" + row.id}
                                                                                type="number"
                                                                                fullWidth
                                                                                size="small"
                                                                                inputProps={{ min: 0 }}
                                                                                value={row.stock}
                                                                                onChange={(e) => changeInputs(row.id, parseInt(e.target.value), 'stock')}
                                                                            />
                                                                        </TableCell> */}

                                                                            <TableCell align="center">
                                                                                {values.discounttype === '3' ? (
                                                                                    <TextField
                                                                                        id={`new_price-${row.id}`}
                                                                                        type="number"
                                                                                        fullWidth
                                                                                        size="small"
                                                                                        value={row.new_price}
                                                                                        onChange={(e) => {
                                                                                            const value = parseFloat(e.target.value);
                                                                                            const updatedFilter = filter.map((product) =>
                                                                                                product.id === row.id ? { ...product, new_price: value } : product
                                                                                            );
                                                                                            setFilter(updatedFilter);
                                                                                        }}
                                                                                        inputProps={{ min: 0 }}
                                                                                    />
                                                                                ) : (
                                                                                    row.new_price ? row.new_price.toFixed(0) : row.price.toFixed(0)
                                                                                )}
                                                                            </TableCell>

                                                                            {/* <TableCell align="center">{row.cointypesymbol + ' ' + (row.price * row.stock)}</TableCell> */}
                                                                        </TableRow>
                                                                    ))
                                                                ) : (
                                                                    <TableRow>
                                                                        <TableCell colSpan={columns ? columns.length : 1}>
                                                                            <Grid sx={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                                                                                <div>{"Sin data"}</div>
                                                                            </Grid>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            }
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>

                                                {/* <Grid item xs={12} display='flex' justifyContent='end' mt={2} >
                                                <Grid item xs={2}>
                                                    <TextField
                                                        id="total"
                                                        type="number" 
                                                        name="total"
                                                        fullWidth
                                                        size="small"
                                                        value={total}
                                                        onChange={handleChange}
                                                        onKeyDown={handleKeyDown}
                                                        inputProps={{ readOnly: true }}
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start">Total:</InputAdornment>,
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid> */}

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                    <CustomFormFooter
                                        buttonType="submit"
                                        confirmText={'Guardar'}
                                        onConfirm={handleSubmit}
                                        cancelText={"Cancelar"}
                                        onCancel={closeModal}
                                        loadingConfirmText={loading}
                                        clearState={clearState}
                                    />
                                </form>
                            )
                        }}
                    </Formik>
                </CustomFormBody>
            </CustomForm>

            {
                showListProducts && (
                    <SelectProductsModal
                        open={showListProducts}
                        closeModal={() => { setShowListProducts(false) }}
                        clearState={clearState}
                        // productsSelected = {productsSelected}
                        productsSelected={filter}
                        setProductsSelected={setProductsSelected}
                        setFilter={setFilter}
                    />
                )
            }
        </>
    )
}